module.exports = __webpack_public_path__ + "static/media/ROXANA WOLLOU.e8abe5ea.png";